import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { Step9 } from '../../../../shared/models/component-messages/blocCommun/mapa/step9';
import { ClasseProfit } from '../../../../../models/eforms/dila/typeadressetempost/classeprofit/ClasseProfit';
import { RadioCheckBoxEnum } from '../../../../formulaires/common/radio.checkbox.enums';
import { AvisDataTransferService } from '../../../../shared/services/avis-data-transfer.service';
import { CanNavigateInStepperService } from '../../../../shared/services/can-navigate-in-stepper.service';
import { FacturationService } from '../../../../formulaires/common/services/facturation/facturation.service';

@Component({
  selector: 'app-classe-profit',
  templateUrl: './classe-profit.component.html'
})
export class ClasseProfitComponent implements OnInit {
  @Input() uid = '';
  public current_uid = 'ClasseProfit';
  @Input() parentForm: FormGroup;
  @Input() classeProfit: ClasseProfit;
  @Input() disabled: boolean;
  public step9 = new Step9();
  public organisme: string;
  radioButtonValue;
  radioButtonCtrlName;
  region = RadioCheckBoxEnum.region;
  departement = RadioCheckBoxEnum.departement;
  etat = RadioCheckBoxEnum.etat;
  debiteurEtranger = RadioCheckBoxEnum.debiteurEtranger;
  autresOrganismesPublics = RadioCheckBoxEnum.autresOrganismesPublics;
  debiteurPrivePersPhysique = RadioCheckBoxEnum.debiteurPrivePersPhysique;
  groupementCollectivites = RadioCheckBoxEnum.groupementCollectivites;
  commune = RadioCheckBoxEnum.commune;
  debiteurPrivePersMorale = RadioCheckBoxEnum.debiteurPrivePersMorale;
  etablissementsPublicsSante = RadioCheckBoxEnum.etablissementsPublicsSante;

  constructor(private avisDataTransferService: AvisDataTransferService, private canNavigateInStepperService: CanNavigateInStepperService,
              private facturationService: FacturationService) {
  }

  private hasExplicitClasseProfit = false;

  public ngOnInit() {
    if (this.classeProfit?.region === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.region;
      this.hasExplicitClasseProfit = true;
    } else if (this.classeProfit?.departement === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.departement;
      this.hasExplicitClasseProfit = true;
    } else if (this.classeProfit?.etat === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.etat;
      this.hasExplicitClasseProfit = true;
    } else if (this.classeProfit?.debiteurEtranger === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.debiteurEtranger;
      this.hasExplicitClasseProfit = true;
    } else if (this.classeProfit?.autresOrganismesPublics === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.autresOrganismesPublics;
      this.hasExplicitClasseProfit = true;
    } else if (this.classeProfit?.debiteurPrivePersPhysique === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.debiteurPrivePersPhysique;
      this.hasExplicitClasseProfit = true;
    } else if (this.classeProfit?.groupementCollectivites === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.groupementCollectivites;
      this.hasExplicitClasseProfit = true;
    } else if (this.classeProfit?.commune === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.commune;
      this.hasExplicitClasseProfit = true;
    } else if (this.classeProfit?.debiteurPrivePersMorale === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.debiteurPrivePersMorale;
      this.hasExplicitClasseProfit = true;
    } else if (this.classeProfit?.etablissementsPublicsSante === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.etablissementsPublicsSante;
      this.hasExplicitClasseProfit = true;
    }

    this.radioButtonCtrlName = this.getUid() + '_SepAtt_region';

  }

  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  isOrganisme() {
    // Ne pas écraser la valeur si une classeProfit explicite a été chargée depuis les données sauvegardées
    if (this.hasExplicitClasseProfit) {
      return true;
    }

    if (!this.canNavigateInStepperService.currentFormulaire?.includes('E_FORM') && this.canNavigateInStepperService.currentFormulaire !== '') {
      if (this.avisDataTransferService.getFormData()?.formulaire?.code?.includes('MAPA')) {
        const mapa = this.avisDataTransferService.getFormData()?.jsonSaisieFormulaire?.ann?.mapa;
        this.organisme = mapa?.organisme?.classificationOrganisme;
      } else if (this.avisDataTransferService.getFormData()?.formulaire?.code?.includes('DIV')) {
        const divers = this.avisDataTransferService.getFormData()?.jsonSaisieFormulaire?.ann?.divers;
        this.organisme = divers?.organisme?.classificationOrganisme;
      }

      switch (this.organisme) {
        case undefined:
          break;
        case '1':
          this.radioButtonValue = this.etat;
          break;
        case '3':
          this.radioButtonValue = this.departement;
          break;
        case '4':
          this.radioButtonValue = this.commune;
          break;
        case '7':
          this.radioButtonValue = this.autresOrganismesPublics;
          break;
        default:
          this.radioButtonValue = this.region;
      }

    }
    return true;
  }

}
